import { Box, CircularProgress, styled } from "@mui/material";
import React from "react";
import { MessageSkeleton } from "../../shared/SkeletonLoader";

const LoadingContainer = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const InitialLoadingContainer = styled(Box)`
  padding: 20px;
`;

interface LoadingStateProps {
  type: "initial" | "more";
  skeletonCount?: number;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  type,
  skeletonCount = 5,
}) => {
  if (type === "initial") {
    return (
      <InitialLoadingContainer>
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <MessageSkeleton
            key={`message-skeleton-${index}`}
            isFromClient={index % 2 === 0}
          />
        ))}
      </InitialLoadingContainer>
    );
  }

  return (
    <LoadingContainer>
      <CircularProgress size={24} />
    </LoadingContainer>
  );
};

export default LoadingState;
